/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import { __assign } from "tslib";
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/schedulesMappers";
import * as Parameters from "../models/parameters";
/** Class representing a Schedules. */
var Schedules = /** @class */function () {
  /**
   * Create a Schedules.
   * @param {LabServicesClientContext} client Reference to the service client.
   */
  function Schedules(client) {
    this.client = client;
  }
  Schedules.prototype.listByLab = function (resourceGroupName, labName, options, callback) {
    return this.client.sendOperationRequest({
      resourceGroupName: resourceGroupName,
      labName: labName,
      options: options
    }, listByLabOperationSpec, callback);
  };
  Schedules.prototype.get = function (resourceGroupName, labName, scheduleName, options, callback) {
    return this.client.sendOperationRequest({
      resourceGroupName: resourceGroupName,
      labName: labName,
      scheduleName: scheduleName,
      options: options
    }, getOperationSpec, callback);
  };
  Schedules.prototype.createOrUpdate = function (body, resourceGroupName, labName, scheduleName, options, callback) {
    return this.client.sendOperationRequest({
      body: body,
      resourceGroupName: resourceGroupName,
      labName: labName,
      scheduleName: scheduleName,
      options: options
    }, createOrUpdateOperationSpec, callback);
  };
  Schedules.prototype.update = function (body, resourceGroupName, labName, scheduleName, options, callback) {
    return this.client.sendOperationRequest({
      body: body,
      resourceGroupName: resourceGroupName,
      labName: labName,
      scheduleName: scheduleName,
      options: options
    }, updateOperationSpec, callback);
  };
  /**
   * Operation to delete a schedule resource.
   * @summary Deletes a schedule resource.
   * @param resourceGroupName The name of the resource group. The name is case insensitive.
   * @param labName The name of the lab that uniquely identifies it within containing lab plan. Used
   * in resource URIs.
   * @param scheduleName The name of the schedule that uniquely identifies it within containing lab.
   * Used in resource URIs.
   * @param [options] The optional parameters
   * @returns Promise<msRest.RestResponse>
   */
  Schedules.prototype.deleteMethod = function (resourceGroupName, labName, scheduleName, options) {
    return this.beginDeleteMethod(resourceGroupName, labName, scheduleName, options).then(function (lroPoller) {
      return lroPoller.pollUntilFinished();
    });
  };
  /**
   * Operation to delete a schedule resource.
   * @summary Deletes a schedule resource.
   * @param resourceGroupName The name of the resource group. The name is case insensitive.
   * @param labName The name of the lab that uniquely identifies it within containing lab plan. Used
   * in resource URIs.
   * @param scheduleName The name of the schedule that uniquely identifies it within containing lab.
   * Used in resource URIs.
   * @param [options] The optional parameters
   * @returns Promise<msRestAzure.LROPoller>
   */
  Schedules.prototype.beginDeleteMethod = function (resourceGroupName, labName, scheduleName, options) {
    return this.client.sendLRORequest({
      resourceGroupName: resourceGroupName,
      labName: labName,
      scheduleName: scheduleName,
      options: options
    }, beginDeleteMethodOperationSpec, options);
  };
  Schedules.prototype.listByLabNext = function (nextPageLink, options, callback) {
    return this.client.sendOperationRequest({
      nextPageLink: nextPageLink,
      options: options
    }, listByLabNextOperationSpec, callback);
  };
  return Schedules;
}();
export { Schedules };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var listByLabOperationSpec = {
  httpMethod: "GET",
  path: "subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labs/{labName}/schedules",
  urlParameters: [Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labName],
  queryParameters: [Parameters.apiVersion, Parameters.filter],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.PagedSchedules
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var getOperationSpec = {
  httpMethod: "GET",
  path: "subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labs/{labName}/schedules/{scheduleName}",
  urlParameters: [Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labName, Parameters.scheduleName],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.Schedule
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var createOrUpdateOperationSpec = {
  httpMethod: "PUT",
  path: "subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labs/{labName}/schedules/{scheduleName}",
  urlParameters: [Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labName, Parameters.scheduleName],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  requestBody: {
    parameterPath: "body",
    mapper: __assign(__assign({}, Mappers.Schedule), {
      required: true
    })
  },
  responses: {
    200: {
      bodyMapper: Mappers.Schedule
    },
    201: {
      bodyMapper: Mappers.Schedule
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var updateOperationSpec = {
  httpMethod: "PATCH",
  path: "subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labs/{labName}/schedules/{scheduleName}",
  urlParameters: [Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labName, Parameters.scheduleName],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  requestBody: {
    parameterPath: "body",
    mapper: __assign(__assign({}, Mappers.ScheduleUpdate), {
      required: true
    })
  },
  responses: {
    200: {
      bodyMapper: Mappers.Schedule
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var beginDeleteMethodOperationSpec = {
  httpMethod: "DELETE",
  path: "subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labs/{labName}/schedules/{scheduleName}",
  urlParameters: [Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labName, Parameters.scheduleName],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {},
    202: {},
    204: {},
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var listByLabNextOperationSpec = {
  httpMethod: "GET",
  baseUrl: "https://management.azure.com",
  path: "{nextLink}",
  urlParameters: [Parameters.nextPageLink],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.PagedSchedules
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};